import React, { createContext, useReducer } from 'react';
import { useUserContext } from './UserContext';

// Объект контекста
export const ContractorsContext = createContext({});

// Начальное состояние задач
const initialState = {
  contractors: [], // Массив задач
  filterBy: '', // Текущий фильтр (статус или другое условие)
  hostname: process.env.REACT_APP_API_URL || "" //process.env.REACT_APP_API_URL
};

// Редюсер для изменения состояния задач
const contractorsReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_CON':
      return {
        ...state,
        contractors: [...state.contractors, action.payload.contractors],
      };
    case 'UPDATE_CON':
      return {
        ...state,
        contractors: state.contractors.map(contractor => {
         return contractor._id === action.payload.id ? action.payload.UPDcontractor : contractor
        }
        ),
      };
    case 'DELETE_CON':
      return {
        ...state,
        contractors: state.contractors.filter(contractor => contractor._id !== action.payload.id),
      };
    // case 'FILTER_TASKS':
    //   return {
    //     ...state,
    //     filterBy: action.payload.filterValue,
    //   };
    case 'GET_CONS':
      return {
        ...state,
        contractors: action.payload.contractors,
      };
    default:
      return state;
  }
};

// Экспорт самого контекста
export default ContractorsContext;
export const ContractorsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(contractorsReducer, initialState);
  const {logout} = useUserContext();
  // Методы для манипуляции задачами
  const addContractors = async (credentials) =>{
    try{
    
    const response = await fetch(initialState.hostname+'/contractors/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        dispatch({
          type: 'ADD_CON',
          payload: { contractors: {...credentials, _id:data.data._id} },
        });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

  const editContractors = async (credentials, id) =>{
    try{
    const response = await fetch(initialState.hostname+'/contractors/update/' + id, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        dispatch({ type: 'UPDATE_CON', payload: { id: id, UPDcontractor: {...credentials, _id: id} } });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

//   const updateTask = updatedTask => {
//     let id =testTask.findIndex((task)=>{ return task.id === updatedTask.id})
//     testTask[id] = updatedTask
//     dispatch({ type: 'UPDATE_TASK', payload: { id: updatedTask.id, updatedTask } });
//   };

  const deleteContractor = async id => {
    try {
      const response = await fetch(initialState.hostname+'/contractors/contractors/'+ id, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'DELETE_CON', payload: { id } });
        return data;
    } catch (error) {
      console.log(error);
    }
    
  };

//   const applyFilter = filterValue => {
//     dispatch({ type: 'FILTER_TASKS', payload: { filterValue } });
//   };

  const getContractors = async () => {
    try {
      const response = await fetch(initialState.hostname+'/contractors/getcontractors', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'GET_CONS', payload: { contractors: data.data } });
        return data;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <ContractorsContext.Provider value={{
      contractors: state.contractors,
      filterBy: state.filterBy,
      addContractors,
      editContractors,
      deleteContractor,
    //   applyFilter,
      getContractors,
    }}>
      {children}
    </ContractorsContext.Provider>
  );
};
export const useContractorsContext = () => {
  const context = React.useContext(ContractorsContext);
  if (!context) throw new Error("useContractorsContext must be used within a UserProvider");
  return context;
};